export default __webpack_public_path__ + "static/media/hand.7a817390.png";